export const ValidateMobileNumber = (phoneNubmer: string) => {
  const re = /^[6-9][0-9]{9}$/;
  return re.test(phoneNubmer);
};

export const validateEmail = (email: string) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validateAlphabeticAndSpace = (text: string) => {
  const re = /^[A-Za-z\s]+$/; 
  return re.test(String(text).toLowerCase());
};

export const NameValidation = (name: string): boolean => {
  const regex = /^[a-zA-Z\s]{3,}$/;
  return regex.test(name);
};